import { render, staticRenderFns } from "./RELPontualidade.vue?vue&type=template&id=05da38f4&"
import script from "./RELPontualidade.vue?vue&type=script&lang=js&"
export * from "./RELPontualidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports